import { AxiosResponse } from "axios";
import { UserFilterRequest, UserStatusFilterRequest } from "@/main/models/request/";
import { Result } from "@/main/models/common/resultResponse";
import {
	ProcurementReportScheduleRequest,
	UserDetailsRequest,
	UserSaveRequest,
} from "@/main/models/request/userRequest";
import { UserDetailResponse, UserSearchGridResponse } from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { KeyValue } from "@/main/models/common";

export abstract class IUserApi {
	abstract getUser(request: UserDetailsRequest): Promise<AxiosResponse<Result<UserDetailResponse>>>;
	abstract saveUser(request: UserSaveRequest): Promise<AxiosResponse<Result<{ guid: string }>>>;
	abstract getSearchGrid(
		request: UserFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<UserSearchGridResponse>>>;
	abstract changeStatusUser(request: UserStatusFilterRequest): Promise<AxiosResponse<Result<void>>>;
	abstract updateIdConnectionSignalR(idConnectionSignalR: string): Promise<AxiosResponse<Result<void>>>;
	abstract getProcurementReportScheduleUsers(
		request: ProcurementReportScheduleRequest,
	): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDomainUsersByCompany(guidCompany: string): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
